import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top seulement
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div>
      {children}
    </div>
  );
};

export default PageTransition; 